import auth from "./auth.action"
import setting from "./setting.action"
import main from "./main.action"

const Actions = {
    auth,setting,main
}

export default Actions